module.exports = __webpack_public_path__ + "static/media/iami.582ef5c8.png";